export default "/images/7a0e7015abbcd46321c9195b940a8338.avif";